import FraudErrorCodes from "@irati/fraud/errorCodes/Fraud"

import RewardErrorCodes from "../../errorCodes/Reward"

export default function rewardErrorHandler(code: string) {
  if (["PBRewardPointsApp", "PBRecognitionApp"].map((svc) => svc + "InvalidRewardAmount").includes(code)) {
    return "errors.MinMaxInvalidRewardAmount"
  }
  switch (code) {
    case RewardErrorCodes.OrderInput:
      return "errors.PBERROrderInput"
    case RewardErrorCodes.OrderNotFound:
      return "errors.PBERROrderNotFound"
    case RewardErrorCodes.OrderCreate:
      return "errors.PBERROrderCreate"
    case RewardErrorCodes.OrderInvalidInput:
      return "errors.PBERROrderInvalidInput"
    case RewardErrorCodes.OrderSnapshot:
      return "errors.PBERROrderSnapshot"
    case RewardErrorCodes.InsufficientStock:
      return "errors.PBERRInsufficientStock"
    case RewardErrorCodes.InvalidJSON:
      return "errors.PBERRInvalidJSON"
    case RewardErrorCodes.InvalidArgument:
      return "errors.PBERRInvalidArgument"
    case RewardErrorCodes.RewardInput:
      return "errors.PBERRRewardInput"
    case RewardErrorCodes.RewardNotFound:
      return "errors.PBERRRewardNotFound"
    case RewardErrorCodes.RewardFilters:
      return "errors.PBERRRewardFilters"
    case RewardErrorCodes.RewardURLSlugExists:
      return "errors.PBERRRewardURLSlugExists"
    case RewardErrorCodes.RewardInternalIdentifierExists:
      return "errors.PBERRRewardInternalIdentifierExists"
    case RewardErrorCodes.NotAllowed:
      return "errors.PBERRNotAllowed"
    case RewardErrorCodes.RewardPayment:
      return "errors.PBREWPayment"
    case FraudErrorCodes.PBPAYFraudThresholdHit:
      return "errors.RewardPBPAYFraudThresholdHit"
    default:
      return ""
  }
}
